import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

import styles from './StyledTableCell.styles';

const StyledTableCell = withStyles(styles)(TableCell);

export default StyledTableCell;
